import firebase from "firebase/compat/app"
import "firebase/compat/auth"

const app = firebase.initializeApp({
    apiKey: "AIzaSyCEA_EW6ok5_Cg3b8dQwcfl4v9iTQ1Hpb4",
    authDomain: "openscopedatafront.firebaseapp.com",
    projectId: "openscopedatafront",  
    storageBucket: "openscopedatafront.appspot.com",
    messagingSenderId: "601910231968",
    appId: "1:601910231968:web:dd19b45c697e87e82edac5",
    measurementId: "G-H45NTKL492"
});

export const auth = app.auth()
export default app